import React from 'react';
import { TargetIcon } from 'lucide-react';
export function IntroSection() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2041">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2042">
        <div className="flex items-start gap-4 p-6 rounded-xl mb-12 shadow-sm" style={{
        backgroundColor: '#ffffff',
        borderLeft: '4px solid #c8a84b',
        borderTop: '1px solid #ede9e0',
        borderRight: '1px solid #ede9e0',
        borderBottom: '1px solid #ede9e0'
      }} data-id="element-2043">
          <TargetIcon className="flex-shrink-0 mt-0.5" size={24} style={{
          color: '#1e3d2f'
        }} data-id="element-2044" />
          <div data-id="element-2045">
            <p className="text-lg font-medium leading-relaxed mb-3" style={{
            color: '#1e3d2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2046">
              The League is open to Boys and Girls 10-18 who are mature enough,
              mentally, and physically, to control the firearm properly.
            </p>
            <p className="text-base leading-relaxed" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2047">
              The attitude and skills developed in this program can lead to a
              lifetime of safe, fun participation in this and other firearm
              sports. For a talented and dedicated person, the path starting
              here could lead to the Olympic Games.
            </p>
          </div>
        </div>
      </div>
    </div>;
}